const GalerieCloud = function(ref, $options = {}){
    var cloud = document.getElementById('galerie-cloud');
    if(cloud) cloud.remove();
    cloud = document.body.createElementInside('div').addClass('galerie-cloud').addAttr('id', 'galerie-cloud');
    cloud.addEventListener('click', function(e){ this.remove();});
    var imgAttr = $options.imgAttr ? $options.imgAttr : 'href';

    const adapter = function(img){
        let wdim = cloud.offset();
        let imgDim = img.offset();
        let wratio = wdim.width / wdim.height;
        let iratio = imgDim.width / imgDim.height;
        let wtp = ( imgDim.width < wdim.width) ? imgDim.width : wdim.width;
        if(wratio > iratio){
            console.log(wdim.height);
            img.removeClass('fluid');
            img.addAttr('style', 'max-height: '+ wdim.height + "px !important");
            //img.setStyle('max-height', wdim.height + "px !important");
            console.log('>>', img);
        }else{
            img.addClass('fluid');
        }
    }

    this.image = function(img, prev, nex){
        var image = cloud.createElementInside('div').addClass('galerie-img');
        var loader = cloud.createElementInside('div').addClass('loader');

        image.setStyle('width', '100%').setStyle('height', '100%');
        var pict = new Image();
        pict.src = img.getAttr(imgAttr);
        var  adapterEvent = function(e){ adapter(pict);}
        pict.addEventListener('load', function(e){
            if(this.complete) {
                loader.remove();
                this.addClass('show').addClass('fluid');
                adapter(this);
                window.addEventListener('resize', adapterEvent);
            }
        });

        image.append(pict);
        var previous = cloud.createElementInside('a').addClass('galerie-previous');
        var next = cloud.createElementInside('a').addClass('galerie-next');
        var close = image.createElementInside('a').addClass('galerie-close');
        previous.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            prev.dispatchEvent(new Event('click'));
        });
        next.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            nex.dispatchEvent(new Event('click'));
        });
    }
}

Element.prototype.galerie = function($options = {}){

    const imgs = this.querySelectorAll('.galerie-thumb');

    this.modalImg = function(e){

        e.preventDefault();
        e.stopPropagation();
        let cloud = new GalerieCloud(this, $options);
        let rand = this.dataset['rand'];
        let previous = (rand > 0) ? imgs[rand - 1] : imgs[imgs.length - 1];
        let next = (rand >= imgs.length - 1) ? imgs[0] : imgs[parseInt(rand) + 1];
        cloud.image(this, previous, next);
    }

    for(let i = 0; i < imgs.length; i++){
        imgs[i].dataset.rand = i;
        imgs[i].addEventListener('click', this.modalImg);
    }

}


